module.exports = __webpack_public_path__ + "static/media/04 REGGIANA CALCIO V. Guasco.2b0b94d2.svg";